import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormControl } from '@angular/forms';
import { SelectPesquisavelComponent } from '../../../../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { FormaFreteItem } from '../../../../../../shared/services/models/vendas/forma-envio-detalhe.model';
import { TipoEntrega } from '../../../../../../shared/services/responses/vendas/forma-envio-lookups.response';
import { environment } from '../../../../../../../environments/environment';
import { TipoContatoEnum } from '../../../../../../shared/enums/pessoa/tipo-contato.enum';

export interface FormaFreteDialogData {
  item: FormaFreteItem | null;
  tiposEntrega: TipoEntrega[];
}

@Component({
  selector: 'app-forma-frete-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    SelectPesquisavelComponent,
  ],
  templateUrl: './forma-frete-dialog.component.html',
  styleUrl: './forma-frete-dialog.component.css',
})
export class FormaFreteDialogComponent implements OnInit {
  public form: FormGroup;
  public transportadorControl = new FormControl<number | null>(null);
  public readonly urlTransportador = `${environment.urlApiPessoa}Lookup/listPessoaSelect?idTipoContato=${TipoContatoEnum.Transportadora}`;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<FormaFreteDialogComponent, FormaFreteItem | null>,
    @Inject(MAT_DIALOG_DATA) public data: FormaFreteDialogData
  ) {}

  ngOnInit(): void {
    const item = this.data.item;
    this.form = this.fb.group({
      descricao: [item?.descricao ?? '', Validators.required],
      codigoServico: [item?.codigoServico ?? null],
      idTipoEntrega: [item?.idTipoEntrega ?? 1],
    });
    if (item?.idPessoaTransportador) {
      this.transportadorControl.setValue(item.idPessoaTransportador);
    }
  }

  public confirmar(): void {
    if (this.form.invalid) return;
    const result: FormaFreteItem = {
      idFormaFrete: this.data.item?.idFormaFrete ?? 0,
      descricao: this.form.value.descricao,
      codigoServico: this.form.value.codigoServico || null,
      codigoSegmento: this.data.item?.codigoSegmento ?? null,
      descSegmento: this.data.item?.descSegmento ?? null,
      idTipoEntrega: this.form.value.idTipoEntrega ?? null,
      idPessoaTransportador: this.transportadorControl.value ?? null,
    };
    this.dialogRef.close(result);
  }

  public cancelar(): void {
    this.dialogRef.close(null);
  }
}
